import React from "react";

export default function ConsolePanel({
  entries,
  onClear,
  onEntryClick,
}){
  return (
    <div className="h-full flex flex-col min-h-0">
      {/* header */}
      <div className="flex items-center justify-between px-3 py-2 border-b bg-gray-50">
        <div className="text-sm text-gray-600">Console</div>
        <div>
          <button onClick={onClear} className="px-2 py-1 text-sm bg-white border rounded">Clear</button>
        </div>
      </div>

      <div className="p-3 overflow-auto text-sm font-mono text-gray-800 bg-white flex-1">
        {entries.length === 0 ? (
          <div className="text-gray-400">No console messages yet. Run the preview to see console output.</div>
        ) : (
          entries.map((e, i) => (
            <div
              key={i}
              onClick={() => onEntryClick && onEntryClick(e)}
              className={`mb-2 ${
                e.type === "error" 
                  ? "text-red-600" 
                  : e.type === "warn" 
                  ? "text-orange-600" 
                  : e.message.includes('🚨 Alert:') || e.message.includes('❓ Confirm:') || e.message.includes('💬 Prompt:')
                  ? "text-blue-600 font-semibold"
                  : "text-gray-800"
              } cursor-pointer hover:bg-gray-50 p-1 rounded`}
              title={e.rule ? `rule: ${e.rule}` : undefined}
            >
              <div className="text-xs text-gray-400">
                {new Date(e.ts).toLocaleTimeString()} {e.source ? `• ${e.source}` : ""} {e.line ? `• ${e.line}:${e.col ?? 1}` : ""}
              </div>
              <div>{e.message}</div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
